export const collections = {
  recommendations: '_recommendations_dev'
}

// Firebase private shit
export const apiKey = "AIzaSyBLY5wF7BVsMiiwcr0OtvK6GxAC_37CkYY"
export const authDomain = "skywrite-5171c.firebaseapp.com"
export const databaseURL = "https://skywrite-5171c.firebaseio.com"
export const projectId = "skywrite-5171c"
  // storageBucket: "redux-firebasev3.appspot.com",
  // messagingSenderId: "823357791673"



// WEBPACK FOOTER //
// ./src/config/constants.js